document.addEventListener("DOMContentLoaded", function () {

  const shareButtons = document.querySelectorAll(
    ".social-sharing-buttons"
  );

  if (!shareButtons) {
    return
  }

  shareButtons.forEach(shareButtons => {
    const sharePopup = shareButtons.querySelector(".share-buttons-popup");
    const copyButton = shareButtons.querySelector(".branding-colors--copy");
    const shareButton = shareButtons.querySelector('.social-sharing-buttons__share-button')

    shareButton.addEventListener("click", function () {
      sharePopup.classList.toggle("share-buttons-popup--show");
    });

    copyButton.addEventListener("click", function (e) {
      e.preventDefault();
      navigator.clipboard
        .writeText(window.location.href)
        .then(() => {
          sharePopup.classList.toggle("share-buttons-popup--show");
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    });

  })
});
